import React, { useState, useEffect } from 'react';
import Verifiers from '../../../../../utils/Verifiers.jsx';
import EditarColor from './EditarColor';
import TablaCatalogos from './TablaCatalogos';
import BotonOpcion from './BotonOpcion';

const ColoresCatalogo = (p) => {

    const show = p.show;
    const data = p.data;
    const datalen = data.length;
    const keys = [//se usa para mostrar los datos en la tabla, key es el nombre del campo y name es como se mostrará al usuario en la tabal el titulo
        { key: 'color', name: 'COLOR' },
        { key: 'descripcion', name: 'DESCRIPCIÓN' },
        { key: 'vrojo', name: 'ROJO' },
        { key: 'vverde', name: 'VERDE' },
        { key: 'vazul', name: 'AZUL' },
        { key: 'relaciones', name: 'BLOQUES ASOCIADOS' }
    ];
    const [resultados, setresultados] = useState([...data]);//lista de elementos qque se muestarn en la interfaz, por defecto son todos los de la lisyta data
    const [filtros, setfiltros] = useState({ asociados: false, sin_asociacion: false, search_word: "" }); //filtros que se aplican a la lista de resultados
    const [guardado_inicial, setgurdado_inicial] = useState(false);
    const [editar, seteditar] = useState(false);
    const [crear, setcrear] = useState(false);

    if (!guardado_inicial) {
        console.log(`agregdo en guardado inicial`);
        if (datalen > 0 && resultados.length === 0) {
            setgurdado_inicial(true);
            setresultados([...data]);
        } else if (datalen > 0 && resultados.length > 0) setgurdado_inicial(true);
    }

    useEffect(() => { aplicarFiltros({ asociados: false, sin_asociacion: false, search_word: "" }); }, [show]);

    const aplicarFiltros = (filtross = { ...filtros }, dataa = [...data]) => {
        let len = dataa.length;
        let result = [];
        let buscar = Verifiers.extraerBloquesUnicos(Verifiers.text_normalice(filtross.search_word));
        let activeSearch = buscar.length > 0;
        if (!filtross.asociados && !activeSearch && !filtross.sin_asociacion) {
            setresultados([...dataa]);
            setfiltros({ ...filtross });
            return;
        }

        for (let i = 0; i < len; i++) {
            if (filtross.sin_asociacion && +dataa[i].relaciones > 0) continue;
            if (filtross.asociados && +dataa[i].relaciones < 1) continue;
            if (activeSearch) {
                let keySearch = Verifiers.text_normalice(`${dataa[i].nombre} ${dataa[i].descripcion} ${dataa[i].relaciones}`);
                if (!Verifiers.elementosEnCadena(keySearch, buscar)) continue;
            }
            result.push(dataa[i]);
        }
        console.log(filtross, [...result]);
        setresultados([...result]);
        setfiltros({ ...filtross });
    }

    const buscar = (event) => {
        let search_word = event.target.value ?? '';
        let fl = { ...filtros, search_word: search_word };
        aplicarFiltros(fl);
    }

    const filtros_existencia = (event) => {
        let name = event.target.name;
        let fl;
        if (name === 'sin_asociacion') fl = { ...filtros, ['asociados']: false, ['sin_asociacion']: !filtros.sin_asociacion };
        else fl = { ...filtros, [name]: !filtros[name], ['sin_asociacion']: false };
        aplicarFiltros(fl);
    }

    const cerrar = (datosActualizar = false) => {
        if (datosActualizar) {
            p.setdatosFlor(datosActualizar);
            aplicarFiltros(filtros, datosActualizar.colores);
        }
        seteditar(null);
        setcrear(null);
    }

    const totalAsociados = () => {
        let total = 0;
        for (let i = 0; i < datalen; i++)if (+data[i].relaciones === 0) total++;
        return total;
    }

    return (
        <div className='w-100 h-100 p-2'>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='form-group bw-200 p-0 m-0 mt-2 mb-2'>
                    <input type='text' className='form-control form-control-sm border border-warning round-xxl shadow-sm'
                        value={filtros.search_word || ""}
                        onChange={buscar}
                        placeholder='buscar por palabras clave' />
                </div>
                <BotonOpcion name='Colores asociadas a bloques' keyName='asociados' isSelected={filtros.asociados} funcion={filtros_existencia} />
                <BotonOpcion name='Sin asociaciones' keyName='sin_asociacion' isSelected={filtros.sin_asociacion} funcion={filtros_existencia} />
                <div className='bw-150 m-0 mt-2 mb-2'>
                    <button className={`w-100 btn btn-sm round-xxl btn-light border-warning border-2 text-bold`}
                        onClick={() => setcrear(true)} >Nuevo color</button>
                </div>
                <div className='bw-200 m-0 mt-2 mb-2'>
                    <button className={`w-100 btn btn-sm round-xxl btn-danger border-black bg-red3 text-white border-2 text-bold`}
                        onClick={() => p.elimnarNoAsociados("color")} disabled={totalAsociados() === 0}>Eliminar no asociados<span className='text-xs text-300 ms-2'>{totalAsociados()}</span></button>
                </div>
                <div className='w-100 m-0 p-0'></div>
                <TablaCatalogos keys={keys} data={resultados} funcion={(res) => { if (!editar) seteditar(res) }}
                    contenedor={'bw-1100 vh-70 round-m bg-white border shadow p-0 mt-1 overflow p-0'} />

            </div>
            {editar && <EditarColor data={editar} close={cerrar} />}
            {crear && <EditarColor data={null} close={cerrar} />}
        </div>
    )
}

export default ColoresCatalogo;